import React from 'react'
import { string, shape, bool } from 'prop-types'
import { view } from '../../stores'

export const LoggedInAs = view(({ authentication, doLogout }) => {
  if (!authentication || !authentication.asAdmin) {
    return <span />
  }
  return (
    <div style={{
      'backgroundColor': 'red',
      'padding': '5px',
      'color': 'white',
      'textAlign': 'center'
    }}>
      Vous êtes connecté en tant que <b>{authentication.email}</b>.
      <a style={{ 'color': 'white', 'cursor': 'pointer' }} onClick={() => doLogout()}><u>Cliquez ici pour fermer proprement cette session.</u></a>
    </div>
  )
})

LoggedInAs.propTypes = {
  authentication: shape({
    asAdmin: bool,
    email: string
  })
}



// WEBPACK FOOTER //
// ./src/components/ui/LoggedInAs.js